
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

const classNames = mergeStyleSets({
    dot: {
        color: getTheme().palette.neutralTertiary,
        paddingRight: 4
    }
});

const ItemDot = () => {
    return (
        <FontIcon iconName="LocationDot" className={classNames.dot} />
    );
}

export default ItemDot;
